import { render, staticRenderFns } from "./ProfileMenuSelection.vue?vue&type=template&id=2b2c3805&scoped=true&"
import script from "./ProfileMenuSelection.vue?vue&type=script&lang=js&"
export * from "./ProfileMenuSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c3805",
  null
  
)

export default component.exports